export enum EmployeeStatus {
	Active = 1,
	Inactive = 2,
	Terminated = 3,
	Retired = 4,
}

export enum EmployeeStatusDescription {
	Active = 'Active',
	Inactive = 'Inactive',
	Terminated = 'Terminated',
	Retired = 'Retired',
}
